// Template Generated by DataExtraction.py at 1716507313

import SKYC1English from "../../Forms/SKYC/SKYC-1English.png";
import SKYC1EnglishLabels from "../../Labels/SKYC/SKYC-1English.json";
import SKYC1French from "../../Forms/SKYC/SKYC-1French.png";
import SKYC1FrenchLabels from "../../Labels/SKYC/SKYC-1French.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab, formatDayFromDate, formatMonthFromDate, formatYearFromDate, drawText as drawTextAtPos
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import {
    calculateAgeOfYoungestBeneficiary,
    calculateApproximateNetWorth, calculateMaxEducationSavingsPlans,
    calculateMonthlyDisposableIncome,
    calculateMonthlyIncomeGross,
    calculateMonthlyIncomeNet,
    calculateTimeHorizon,
    calculateTotalFinancialAssets,
    calculateTotalMonthlyExpenses,
    calculateYearlyIncomeGross, isDisposableIncomeExceeded, isEightyYearRuleExceeded, isKnowYourClientFormComplete
} from "../../../Utils/KYCUtils";
import { t } from "i18next";
import { displayCurrency } from "../../../Utils/FormattingUtils";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? SKYC1FrenchLabels : SKYC1EnglishLabels;
    const formImage = isFrench ? SKYC1French : SKYC1English;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label, colorOverride = null, bold = false) {
        drawTextOnLabel(doc, value, label, labels, colorOverride, bold);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const common = data.common;
    const kyc = data.knowYourClient;
    const plan = data.plan;
    const application = data.application;

    const planTypeID = plan.planTypeID;

    const subscriber2Include = common.subscriber2Include;

    const s1Name = subscriber.firstName + (subscriber.lastName ? " " + subscriber.lastName : "");
    const s2Name = jointSubscriber.firstName + (jointSubscriber.lastName ? " " + jointSubscriber.lastName : "");

    const d1 = data.dependant;
    const d2 = data.dependant2;
    const d3 = data.dependant3;
    const d4 = data.dependant4;
    const d5 = data.dependant5;

    const beneficiary = data.beneficiary;

    const dateFormat = "MM/DD/yyyy";

    const planTypeMappings = {
        "-1": "",
        0: "Group",
        1: "Self-Initiated",
        2: "Achievers",
    }

    const planType = planTypeMappings[planTypeID];

    const {
        monthlyMaximumEducationSavingsPlan,
        monthlyMaximumEducationSavingsPlanGroup
    } = calculateMaxEducationSavingsPlans(subscriber, jointSubscriber, kyc);

    // Drawing the form
    // TODO in the ipad if monthlyExpensesTotal is 0 then things should be hidden per ln 587 of KYCSViewController.m

    if (planTypeID === 0) { // Group
        drawText("(H)", "affordabilityGroup", null, true);
        drawText(t("Yes"), "affordabilityYesNo");
    } else if (planTypeID === 1) { // Self-Initiated
        // drawText("affordabilitySelfInitiated", "affordabilitySelfInitiated"); // doesn't exist
        drawText(t("No"), "affordabilityYesNo");
    } else if (planTypeID === 2) { // Achievers
        drawText(t("Yes"), "affordabilityYesNo");
        drawText("(H)", "affordabilityAchievers", null, true);
    }


    drawTextAtPos(doc, 12, t("Yes"), 300 / 3.38, 730 / 3.38, 454 / 3.38);

    drawText(`${calculateAgeOfYoungestBeneficiary(beneficiary, kyc)}`, "ageOfYoungestBene");
    drawText(kyc.anticipateKeepContributions ? t("Yes") : t("No"), "anticipateKeepContributions");
    drawText(kyc.pepYN ? t("Yes") : t("No"), "PEPYN", kyc.pepYN ? {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    } : null);



    drawText(displayCurrency(calculateApproximateNetWorth(kyc), i18n.language), "approxNetWorth");
    drawText(displayCurrency(kyc.ccbMonthlyIncomeGross, i18n.language), "ccbGross");
    drawText(displayCurrency(kyc.ccbMonthlyIncomeGross, i18n.language), "ccbNet");
    drawText(displayCurrency(kyc.childCare, i18n.language), "childCare");
    drawText(displayCurrency(kyc.clothing, i18n.language), "clothing");

    if (kyc.numberOfDependants >= 1) {
        // d1
        drawText(d1.yearsOfEducationalSupport, "d1Edu");
        let d1Name = d1.name;
        let d1Birthdate = moment(d1.birthdate).format(dateFormat);

        if (kyc.beneficiaryIsADependant) {
            d1Name = beneficiary.firstName + (beneficiary.lastName ? " " + beneficiary.lastName : "");
            d1Birthdate = moment(beneficiary.birthdate).format(dateFormat);
        }

        drawText(d1Name, "d1Name");
        drawText(d1Birthdate, "d1Birthdate");

    }

    if (kyc.numberOfDependants >= 2) {
        // d2
        drawText(moment(d2.birthdate).format(dateFormat), "d2Birthdate");
        drawText(d2.yearsOfEducationalSupport, "d2Edu");
        drawText(d2.name, "d2Name");
    }
    
    if (kyc.numberOfDependants >= 3) {
        // d3
        drawText(moment(d3.birthdate).format(dateFormat), "d3Birthdate");
        drawText(d3.yearsOfEducationalSupport, "d3Edu");
        drawText(d3.name, "d3Name");
    }
    
    if (kyc.numberOfDependants >= 4) {
        // d4
        drawText(moment(d4.birthdate).format(dateFormat), "d4Birthdate");
        drawText(d4.yearsOfEducationalSupport, "d4Edu");
        drawText(d4.name, "d4Name");
    }
    
    if (kyc.numberOfDependants >= 5) {
        // d5
        drawText(moment(d5.birthdate).format(dateFormat), "d5Birthdate");
        drawText(d5.yearsOfEducationalSupport, "d5Edu");
        drawText(d5.name, "d5Name");
    }

    drawText(displayCurrency(kyc.deposits, i18n.language), "deposits");
    drawText(displayCurrency(calculateMonthlyDisposableIncome(subscriber, jointSubscriber, kyc), i18n.language), "disposableIncome", calculateMonthlyDisposableIncome(subscriber, jointSubscriber, kyc) < 0 ? {
        r: 255,
        g: 0,
        b: 0,
        a: 255
    } : null);
    drawText(kyc.existingSubscriber ? t("Yes") : t("No"), "existingSubscriber");

    drawText(isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc) ? t("Disposable Income Exceeded") : "", "diExceeded", isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc) ? {
        r: 255,
        g: 0,
        b: 0,
        a: 255
    } : null);
    drawText(isEightyYearRuleExceeded(subscriber, jointSubscriber, kyc, common) ? t("Note deposit schedule and subscriber's 80th birthday") : "", "eightyYearRule", isEightyYearRuleExceeded(subscriber, jointSubscriber, kyc, common) ? {
        r: 255,
        g: 0,
        b: 0,
        a: 255
    } : null);

    if (!isKnowYourClientFormComplete(subscriber, jointSubscriber, kyc, common)) {
        drawText(t("Form Incomplete"), "formIncomplete", {
            r: 255,
            g: 0,
            b: 0,
            a: 255
        });
    }
    function drawLongText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, false, true);
    }
    drawText(displayCurrency(kyc.groceries, i18n.language), "groceries");
    drawText(displayCurrency(kyc.insurance, i18n.language), "insurance");
    drawText(common.borrowingToInvest ? t("Yes") : t("No"), "leveraging", common.borrowingToInvest ? {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    } : null);
    drawText(displayCurrency(kyc.liabilities, i18n.language), "liabilities");
    drawText(displayCurrency(monthlyMaximumEducationSavingsPlan, i18n.language), "maximumEsp", null, true);
    drawText(displayCurrency(monthlyMaximumEducationSavingsPlanGroup, i18n.language), "maximumEspGroup", null, true);
    drawText(displayCurrency(kyc.miscellaneous, i18n.language), "miscellaneous");
    drawText(displayCurrency(kyc.morgageCondoFeesRent, i18n.language), "mortgage");
    drawText(kyc.objective, "objective");
    drawLongText(kyc.drReason, "drReason");
    drawText(displayCurrency(kyc.otherAssets, i18n.language), "otherAssets");
    drawText(displayCurrency(kyc.otherContractualObligations, i18n.language), "otherContractualObligations");
    drawText(displayCurrency(kyc.otherMonthlyIncomeGross, i18n.language), "otherGross");
    drawText(displayCurrency(kyc.otherMonthlyIncomeNet, i18n.language), "otherNet");
    drawText(displayCurrency(kyc.paymentOnLoansAndDebts, i18n.language), "paymentsOnLoansAndDebts");
    drawText(t(planType), "planType");
    drawText(t(kyc.riskTolerance), "riskTolerance");

    drawText(formatDayFromDate(subscriber.birthdate), "s1DobDay");
    drawText(formatMonthFromDate(subscriber.birthdate), "s1DobMonth");
    drawText(formatYearFromDate(subscriber.birthdate), "s1DobYear");
    drawText(subscriber.employer, "s1Employer");
    drawText(displayCurrency(subscriber.monthlyIncomeGross, i18n.language), "s1Gross");
    drawText(t(subscriber.investmentExperience), "s1InvestmentExperience");
    drawText(subscriber.investmentTypes, "s1InvestmentTypes");
    drawText(s1Name, "s1Name");
    drawText(displayCurrency(subscriber.monthlyIncomeNet, i18n.language), "s1Net");
    drawText(subscriber.occupation, "s1Occupation");
    if (subscriber2Include) {
        drawText(formatDayFromDate(jointSubscriber.birthdate), "s2DobDay");
        drawText(formatMonthFromDate(jointSubscriber.birthdate), "s2DobMonth");
        drawText(formatYearFromDate(jointSubscriber.birthdate), "s2DobYear");
        drawText(jointSubscriber.employer, "s2Employer");
        drawText(displayCurrency(jointSubscriber.monthlyIncomeGross, i18n.language), "s2Gross");
        drawText(t(jointSubscriber.investmentExperience), "s2InvestmentExperience");

        //TODO this is broken in french! s2InvestmentTypes is not found in labels
        drawText(jointSubscriber.investmentTypes, "s2InvestmentTypes");

        drawText(s2Name, "s2Name");
        drawText(displayCurrency(jointSubscriber.monthlyIncomeNet, i18n.language), "s2Net");
        drawText(jointSubscriber.occupation, "s2Occupation");
    }
    drawText(displayCurrency(kyc.securities, i18n.language), "securities");
    drawText(application.tcpEmail, "tcpEmail");
    drawText(application.tcpName, "tcpName");
    drawText(application.tcpPhone, "tcpPhone");
    drawText(application.tcpRelationship, "tcpRelationship");
    drawText(calculateTimeHorizon(beneficiary, kyc), "timeHorizon");
    drawText(displayCurrency(calculateTotalMonthlyExpenses(kyc), i18n.language), "totalExpenses");
    drawText(displayCurrency(calculateTotalFinancialAssets(kyc), i18n.language), "totalFinancialAssets");
    drawText(displayCurrency(calculateMonthlyIncomeGross(subscriber, jointSubscriber, kyc), i18n.language), "totalGross");
    drawText(displayCurrency(calculateMonthlyIncomeNet(subscriber, jointSubscriber, kyc), i18n.language), "totalNet");
    drawText(displayCurrency(kyc.transportation, i18n.language), "transportation");
    drawText(displayCurrency(kyc.utilities, i18n.language), "utilities");
    drawText(kyc.vehicles, "vehicles");
    drawText(calculateYearlyIncomeGross(subscriber, jointSubscriber, kyc), "yearlyIncomeGross");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? SKYC1FrenchLabels : SKYC1EnglishLabels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];


    return signers;
}

export default {
    generate,
    signatureDefinitions
}

